import EmailAddress from "common/values/email-address/email-address";
import Guid from "common/values/guid/guid";
import Name, { NameJSON } from "common/values/name/name";

export interface UserProfileJSON {
  id: string;
  fullName?: NameJSON;
  firstName?: string;
  lastName?: string;
  email?: string | null;
  isClientRep: boolean;
  isVendorRep: boolean;
}

export default class UserProfile {
  public readonly id: Guid;
  public readonly fullName: Name;
  public readonly email: EmailAddress | null | undefined;
  public readonly isClientRep: boolean;
  public readonly isVendorRep: boolean;

  constructor(
    id: Guid,
    fullName: Name,
    email: EmailAddress | null | undefined,
    isClientRep: boolean,
    isVendorRep: boolean
  ) {
    this.id = id;
    this.fullName = fullName;
    this.email = email;
    this.isClientRep = isClientRep;
    this.isVendorRep = isVendorRep;
  }

  public static fromJSON(json: UserProfileJSON): UserProfile {
    if (!json.id)
      throw new Error("User profile id is required");
    if (!json.fullName) {
      if (!json.firstName)
        throw new Error("User profile first name is required");
      if (!json.lastName)
        throw new Error("User profile last name is required");
    }

    const id = Guid.fromJSON(json.id);
    const fullName = Name.fromJSON(json.fullName || { firstName: json.firstName, lastName: json.lastName });
    const email = json.email ? EmailAddress.fromJSON(json.email) : undefined;
    const isClientRep = json.isClientRep;
    const isVendorRep = json.isVendorRep;

    if (!id)
      throw new Error("User profile id is required");
    if (!fullName)
      throw new Error("User profile full name is required");

    return new UserProfile(id, fullName, email ?? null, isClientRep, isVendorRep);
  }

  public toJSON(): UserProfileJSON {
    return {
      id: this.id.toJSON(),
      fullName: this.fullName.toJSON(),
      email: this.email?.toJSON(),
      isClientRep: this.isClientRep,
      isVendorRep: this.isVendorRep
    };
  }
}
